export default "__VITE_ASSET__z6Gn58Du__"